import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SpinningLoader from '../ui/SpinningLoader';

interface RequireAuthProps {
  children: React.ReactElement;
}

// Route guard: unauthenticated users are redirected to /login, preserving the
// attempted location so login can send them back.
const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="dashboard-content">
        <div className="dashboard-loading">
          <SpinningLoader size="large" text="Loading…" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default RequireAuth;
